import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'
import { cn } from '@/lib/utils'

/**
 * Fluent 2 Switch Component
 * https://fluent2.microsoft.design/components/web/react/core/switch/usage
 * Track height: 20px, Thumb: 14px circle, Brand color when checked
 */
const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-5 w-10 shrink-0 cursor-pointer items-center rounded-full border border-neutral-400 transition-colors',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0c00ff] focus-visible:ring-offset-2 focus-visible:ring-offset-white',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:bg-[#0c00ff] data-[state=checked]:border-[#0c00ff]',
      'data-[state=unchecked]:bg-neutral-100',
      'hover:data-[state=unchecked]:border-neutral-500',
      'dark:border-neutral-500 dark:data-[state=unchecked]:bg-neutral-800',
      'dark:data-[state=checked]:bg-[#479ef5] dark:data-[state=checked]:border-[#479ef5]',
      'dark:focus-visible:ring-[#479ef5] dark:focus-visible:ring-offset-neutral-950',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-3.5 w-3.5 rounded-full bg-white shadow-sm ring-0 transition-transform',
        'data-[state=checked]:translate-x-[18px] data-[state=unchecked]:translate-x-0.5',
        'data-[state=unchecked]:bg-neutral-600 data-[state=checked]:bg-white',
        'dark:data-[state=unchecked]:bg-neutral-400'
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }